import "../../css/viewhistorydata.css";
import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretLeft } from "@fortawesome/free-solid-svg-icons";
import LoggedInContainer from "../../layout/LoggedInContainer";
import ViewFeedPerDeck from "./View";
import { getConsignmentDeckAnimals, setCompletedConsignmentDaysForConsignmentIDAsViewed } from "../../api/apiAccess";
import { UserContext, MediaQueryContext } from "../..";
import AverageDeckWeightModal from "../../components/FeedPerDeck/AverageDeckWeightModal"
import { UserType } from "../../api/enums/EnumUserType";

const ViewFeedPerDeckHistory = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { consignmentID } = useParams();
  const userCtx = useContext(UserContext);
  const mediaQueryCtx = useContext(MediaQueryContext);

  const [selectedColumnIndex, setSelectedColumnIndex] = useState("");
  const [isEditable, setIsEditable] = useState(false);

  const [showAverageDeckWeightModal, setShowAverageDeckWeightModal] = useState(false);

  useEffect(() => {
    // check if this consignment has cattle or sheep (if not the "Other" tab in not displayed)
    const setHasCattleOrSheep = async () => {
      let lResponse = await getConsignmentDeckAnimals(consignmentID);

      if (lResponse?.status === 200) {

      } else {
        //todo
        return null;
      }
    };

    setHasCattleOrSheep();
  }, []);

  useEffect(() => {
    if (!location || !location.state) {
      navigate("/Dashboard");
    }
    if (location?.state?.focusedTab) {
      //let lSelectedTabID = tabs.find((tab) => tab.name.toLowerCase() === location.state.focusedTab).value;
    }

    if (location?.state?.selectedColumnIndex) {
      setSelectedColumnIndex(location.state.selectedColumnIndex);
    }

    if (location?.state?.editable) {
      setIsEditable(location.state.editable);
    }
  }, [location]);

  useEffect(() => {
    const updateIsReviewedStatus = async () => {
      if (userCtx.user?.orgTypeID === 1) {
        await setCompletedConsignmentDaysForConsignmentIDAsViewed(consignmentID);
      }
    }
    if (consignmentID) {
      updateIsReviewedStatus();
    }
  }, [consignmentID])

  const handleSelectedColumnIndexChanged = (index) => {
    setSelectedColumnIndex(index);
  }

  const goBack = () => {
    navigate(`/consignmentdashboard/${consignmentID}`, { state: { isHistorical: location?.state?.isHistorical } });
  };

  return (
    <LoggedInContainer>
      <Container fluid className="p-0" style={{ backgroundColor: "#F5F5F5" }}>
        <Row className="upper-panel mx-0" style={{ position: "relative" }}>
          {
            mediaQueryCtx.mobile === true ? (
              <Col xs={12}>
                <Container>
                  <Row style={{ marginTop: "36px" }}>

                    <Col xs={12}>
                      <div className="text-center heading-text mb-2 mt-3" style={{ color: "#FFF", display: "inline" }}>
                        <div style={{ lineHeight: "53px", fontSize: "35px" }}>View Exporter Feed</div>
                      </div>
                    </Col>
                    <Col xs={6} className="mt-3">
                      <Button className="w-100" variant="back" onClick={() => goBack()}>
                        <FontAwesomeIcon icon={faCaretLeft} style={{ marginRight: "5px" }} />Back
                      </Button>
                    </Col>
                    <Col xs={6} className="mt-3">
                      {
                        userCtx.user?.orgTypeID === UserType.INDUSTRY &&
                        <Button className="w-100" variant="back" onClick={() => setShowAverageDeckWeightModal(true)} style={{ display: "inline" }}>
                          Add Weights
                        </Button>
                      }
                    </Col>

                  </Row>
                </Container>
              </Col>
            ) : (
              <Col xs={12}>
                <Container>
                  <Row style={{ marginTop: "65px" }}>
                    <Col xs={2}>
                      <Button variant="back" onClick={() => goBack()}>
                        <FontAwesomeIcon icon={faCaretLeft} style={{ marginRight: "5px" }} />Back
                      </Button>
                    </Col>
                    <Col>
                      <div className="text-center heading-text mb-2 mt-3" style={{ color: "#FFF", display: "inline" }}>
                        <div style={{ lineHeight: "53px", fontSize: "35px" }}>View Exporter Feed</div>
                      </div>
                    </Col>
                    <Col xs={2} style={{ textAlign: "right" }}>
                      {
                        userCtx.user?.orgTypeID === UserType.INDUSTRY &&
                        <Button variant="back" onClick={() => setShowAverageDeckWeightModal(true)} style={{ display: "inline" }}>
                          Add Weights
                        </Button>
                      }
                    </Col>
                  </Row>
                </Container>
              </Col>
            )

          }

        </Row>
        <Row className="mx-0">
          <Col>
            <Container className="py-4 px-5 form-container-mid" style={{ top: "-350px" }}>
              <ViewFeedPerDeck consignmentID={consignmentID} selectedColumnIndex={selectedColumnIndex} allowEditing={isEditable} onSelectedColumnIndexChanged={handleSelectedColumnIndexChanged} />
              <AverageDeckWeightModal consignmentID={consignmentID} showModal={showAverageDeckWeightModal} setShowModal={setShowAverageDeckWeightModal} />
            </Container>
          </Col>
        </Row>
      </Container>
    </LoggedInContainer>
  );
};

export default ViewFeedPerDeckHistory;
